import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  label: {
    marginRight: theme.spacing(2)
  },
  button: {
    minWidth: 60
  },
  activeButton: {
    color: theme.palette.common.white,
    border: "1px solid transparent",
    padding: "3px 9px"
  }
}));
